export default "__VITE_ASSET__Li$Q0Aq2__"